const CLIENT_VERSION = "3.09";
  
export default CLIENT_VERSION;